import * as BABYLON from '@babylonjs/core';
import * as GUI from '@babylonjs/gui';

class GuiTextBlockManaged {
    textBlockInst = undefined
    fullscreenUi = undefined
    canvas = undefined

    //TODO: Destructor?
    constructor(fullscreenUi, canvas, text) {
        var textBlock = new GUI.TextBlock();
        textBlock.color = "orange";
        textBlock.fontSize = 17;
        textBlock.width = '300px'
        fullscreenUi.addControl(textBlock);

        this.textBlockInst = textBlock;
        this.fullscreenUi = fullscreenUi;
        this.canvas = canvas;

        this.updateText(text)
    }

    updatePosition(positionSS) {
        //console.log(positionSS);
        //positionSS = BABYLON.Vector3.Zero();
        this.textBlockInst.left = positionSS.x - this.canvas.width * 0.5;
        this.textBlockInst.top = positionSS.y - this.canvas.height * 0.5;
    }

    updateText(textStr) {
        textStr = textStr || "";
        this.textBlockInst.text = textStr;
        var textWidth = this.fullscreenUi.getContext().measureText(textStr).width;
        this.textBlockInst.width = textWidth;
    }

    updateColor(color, alpha) {
        this.textBlockInst.color = color.toHexString();
        this.textBlockInst.alpha = alpha;
    }
}

export default GuiTextBlockManaged;